import { ArrowLeft, BookOpenCheck } from "lucide-react";
import { ProfessorPlanningEditor } from "./ProfessorPlanningEditor";
import type { ProfessorAulaHoje } from "./professorApi";

export function ProfessorPlanningScreen({ aula, onBack, onSaved }: { aula: ProfessorAulaHoje; onBack: () => void; onSaved?: () => void }) {
  return <main className="professor-mobile professor-workspace mx-auto app-lifestyle min-h-screen px-4 pb-10 text-white sm:px-5">
    <div className="professor-detail-body mx-auto max-w-lg">
      <header className="professor-detail-header sticky top-0 z-30 -mx-4 border-b border-white/8 bg-[#030708]/92 px-4 pb-4 pt-[max(1rem,env(safe-area-inset-top))] backdrop-blur-xl sm:-mx-5 sm:px-5">
        <div className="flex items-center gap-3">
          <button type="button" onClick={onBack} className="glass-icon flex h-11 w-11 shrink-0 items-center justify-center rounded-full" aria-label="Voltar">
            <ArrowLeft className="h-5 w-5"/>
          </button>
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-black uppercase tracking-[.14em] text-teal-light">Planejamento de aula</p>
            <h1 className="break-words font-display text-lg font-semibold">{aula.turmaNome}</h1>
            <p className="mt-0.5 text-[11px] text-white/65">{dateLabel(aula.data)} · {aula.horaInicio.slice(0,5)}–{aula.horaFim.slice(0,5)}</p>
          </div>
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-teal/10 text-teal-light"><BookOpenCheck className="h-5 w-5"/></span>
        </div>
      </header>

      <div className="mt-4 rounded-2xl border border-white/8 bg-white/[.025] p-4">
        <strong className="text-sm text-white/80">Planejamento independente da execução</strong>
        <p className="mt-1 text-xs leading-5 text-white/65">Preparar, editar ou publicar o plano não inicia a aula e não altera chamada, presença ou sessão.</p>
      </div>

      <ProfessorPlanningEditor aula={aula} planoId={aula.planoAulaId} onCancel={onBack} onSaved={()=>{onSaved?.();onBack();}}/>
    </div>
  </main>;
}

function dateLabel(value:string){const [y,m,d]=value.slice(0,10).split("-");return `${d}/${m}/${y}`}
